<mat-card>
  <mat-horizontal-stepper #stepper>
    <mat-step label="{{ settings.lang.selectExcelFile }}">
      <a
        href="https://youtu.be/Jtmhyf8-E4g"
        target="_blank"
        class="no-print"
        *ngIf="settings.showVideo()"
        style="margin-right: 10px"
        >{{ settings.lang.excelImportVideo }}</a
      >
      <h3>{{ settings.lang.selectExcelFile }}</h3>
      <input type="file" #file (input)="fileChange($event)" />
    </mat-step>
    <mat-step label="{{ settings.lang.mapExcelColumns }}">
      <ng-container *ngIf="filename">
        <button (click)="loadSettings()" mat-raised-button>
          {{ settings.lang.loadExcelSettings }}
        </button>
        <button (click)="clearSettings()" mat-raised-button>
          {{ settings.lang.deleteExcelSettings }}
        </button>
        <button
          (click)="saveSettings(); moveToAdvancedSettings()"
          mat-flat-button
        >
          {{ settings.lang.nextStep }}
        </button>

        <h4>{{ settings.lang.addColumnsThatAreNotInTheFile }}</h4>

        <ul>
          <li *ngFor="let ac of additionalColumns; let i = index">
            <select [(ngModel)]="ac.field">
              <option value="">{{ settings.lang.excelColumnIgnore }}</option>
              <option *ngFor="let c of columns" [ngValue]="c">
                {{ c.name }}
              </option>
            </select>
            <input [(ngModel)]="ac.value" />
            <button (click)="additionalColumns.splice(i, 1)">
              {{ settings.lang.remove }}
            </button>
          </li>
        </ul>
        <button (click)="additionalColumns.push({})" mat-raised-button>
          {{ settings.lang.addExcelColumn }}
        </button>

        <h4>
          {{ settings.lang.columnSelectionInFile }} "{{ this.filename }}",
          {{ settings.lang.excelSheet }}: "{{ sheet }}"
        </h4>

        <div class="table-div">
          <table class="table table-bordered">
            <tr>
              <th>#</th>

              <th *ngFor="let ec of excelColumns">
                {{ ec.title }}
                <br />
                <select [(ngModel)]="ec.field">
                  <option value="">
                    {{ settings.lang.excelColumnIgnore }}
                  </option>
                  <option *ngFor="let c of columns" [ngValue]="c">
                    {{ c.name }}
                  </option>
                </select>
              </th>
            </tr>
            <ng-container *ngFor="let r of rows">
              <tr>
                <td>{{ r }}</td>

                <td *ngFor="let c of excelColumns">
                  {{ getTheData(c.excelField + r) }}
                </td>
              </tr>
            </ng-container>
          </table>
        </div>

        {{ settings.lang.total }} {{ rows.length }}
        {{ settings.lang.linesInExcel }}
      </ng-container>
    </mat-step>
    <mat-step label="{{ settings.lang.excelImportFinalSettings }}">
      <button (click)="testImport()" mat-flat-button>
        {{ settings.lang.nextStep }}
      </button>
      <h3>{{ settings.lang.excelImportFinalSettings }}</h3>

      <data-area [settings]="settingsArea" *ngIf="settingsArea"></data-area>
    </mat-step>
    <mat-step label="{{ settings.lang.executeExcelImport }}">
      <h3>{{ settings.lang.excelImportResults }}</h3>
      <mat-tab-group>
        <mat-tab
          label="{{ settings.lang.errors }} -  {{ errorRows.length }}"
          *ngIf="errorRows && errorRows.length"
        >
          <div class="table-div">
            <table class="table table-bordered" style="white-space: nowrap">
              <tr>
                <th></th>
                <th *ngFor="let c of columnsInCompare">
                  {{ c.c.caption }}
                </th>
              </tr>
              <ng-container *ngFor="let i of errorRows">
                <tr
                  [class.disabledErrorRow]="i.userIgnoreError"
                  class="top-error-row"
                >
                  <td>
                    <mat-checkbox
                      [(ngModel)]="i.userIgnoreError"
                    ></mat-checkbox>
                    {{ i.rowInExcel }}
                  </td>
                  <td *ngFor="let c of columnsInCompare">
                    {{ getColInfo(i, c).newDisplayValue }}
                  </td>
                </tr>
                <ng-container *ngIf="!i.userIgnoreError">
                  <tr *ngIf="!i.otherExcelRow">
                    <td colspan="100">
                      <span class="error">{{ i.error }}</span>

                      <ul
                        *ngIf="
                          i.duplicateFamilyInfo &&
                          i.duplicateFamilyInfo.length >= 1
                        "
                      >
                        <li
                          *ngFor="let f of i.duplicateFamilyInfo"
                          [class.error]="f.removedFromList"
                        >
                          {{ f.name }} - {{ displayDupInfo(f) }} -
                          <a (click)="updateFamily(f)">{{
                            settings.lang.familyDetails
                          }}</a>
                          <br />
                          <a (click)="moveFromErrorToUpdate(i, f)"
                            ><span *ngIf="i.duplicateFamilyInfo.length > 1">{{
                              settings.lang.excelCompareToThisFamilyAnd
                            }}</span>
                            {{ settings.lang.moveToUpdateFamilies }}</a
                          >
                        </li>
                      </ul>
                      <a (click)="moveFromErrorToAdd(i)"
                        ><span
                          *ngIf="
                            i.duplicateFamilyInfo &&
                            i.duplicateFamilyInfo.length > 1
                          "
                        >
                          {{
                            settings.lang.excelNoneOfTheseFamiliesMatch
                          }}</span
                        >
                        {{ settings.lang.moveToNewFamilies }}</a
                      >
                    </td>
                  </tr>
                  <ng-container *ngIf="i.otherExcelRow">
                    <tr>
                      <td colspan="100">
                        <span class="error">{{ i.error }}</span>
                      </td>
                    </tr>
                    <tr style="background-color: lightgoldenrodyellow">
                      <td>{{ i.otherExcelRow.rowInExcel }}</td>
                      <td
                        *ngFor="let c of columnsInCompare"
                        [class.match]="
                          getColInfo(i.otherExcelRow, c).newDisplayValue ==
                          getColInfo(i, c).newDisplayValue
                        "
                      >
                        {{ getColInfo(i.otherExcelRow, c).newDisplayValue }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="100">
                        <a (click)="moveFromErrorToProcess(i)"
                          >{{ settings.lang.readExcelRow }} {{ i.rowInExcel }}
                          {{ settings.lang.excelReadLineAnyhow }}</a
                        >
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
              </ng-container>
            </table>
          </div>

          <div style="height: 35px">
            <mat-checkbox [(ngModel)]="stopAskingQuestions">{{
              settings.lang.stopAskingForConfirmation
            }}</mat-checkbox>
          </div>
        </mat-tab>
        <mat-tab
          label="{{ settings.lang.familiesForUpdate }} - {{
            updateRows.length
          }}"
          *ngIf="updateRows && updateRows.length"
        >
          <div class="table-div">
            <table class="table table-bordered" style="white-space: nowrap">
              <tr>
                <th></th>
                <th></th>
                <th *ngFor="let c of columnsInCompare">
                  {{ c.c.caption }}
                  <mat-icon
                    style="color: green"
                    *ngIf="getColUpdateCount(c) > 0"
                    (click)="updateAllCol(c)"
                    >done_all
                  </mat-icon>
                </th>
              </tr>
              <ng-container *ngFor="let i of updateRows">
                <tr>
                  <td>
                    <mat-menu #updatedRowOptions="matMenu">
                      <button mat-menu-item (click)="openFamilyInfo(i)">
                        {{ settings.lang.familyDetails }}
                      </button>
                      <button mat-menu-item (click)="familyHistory(i)">
                        {{ settings.lang.familyHistory }}
                      </button>
                      <button
                        mat-menu-item
                        (click)="updateRows.splice(updateRows.indexOf(i), 1)"
                      >
                        {{ settings.lang.removeFromFamiliesToUpdate }}
                      </button>
                      <button mat-menu-item (click)="moveFromUpdateToAdd(i)">
                        {{ settings.lang.moveToNewFamilies }}
                      </button>
                    </mat-menu>

                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="updatedRowOptions"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  </td>
                  <td>{{ i.rowInExcel }}<br /></td>
                  <td *ngFor="let c of columnsInCompare">
                    <span
                      [class.newValue]="
                        i.duplicateFamilyInfo &&
                        i.duplicateFamilyInfo.length == 1 &&
                        getColInfo(i, c).newDisplayValue !=
                          getColInfo(i, c).existingDisplayValue
                      "
                    >
                      {{ getColInfo(i, c).newDisplayValue }}</span
                    >
                    <ng-container
                      *ngIf="
                        i.duplicateFamilyInfo &&
                        i.duplicateFamilyInfo.length == 1 &&
                        getColInfo(i, c).newDisplayValue !=
                          getColInfo(i, c).existingDisplayValue
                      "
                    >
                      <br /><span
                        style="color: red; text-decoration-line: line-through"
                        >{{ getColInfo(i, c).existingDisplayValue }}</span
                      >
                      <mat-icon
                        style="color: red"
                        (click)="clearColumnUpdate(i, c)"
                        >close
                      </mat-icon>
                      <mat-icon style="color: green" (click)="updateCol(i, c)"
                        >done</mat-icon
                      >
                    </ng-container>
                  </td>
                </tr>
              </ng-container>
            </table>
          </div>
        </mat-tab>
        <mat-tab
          label="{{ settings.lang.newFamilies }} - {{ newRows.length }}"
          *ngIf="newRows && newRows.length"
        >
          <button (click)="addAll()" mat-flat-button>
            {{ settings.lang.addAllFamilies }}
          </button>
          <div class="table-div">
            <table class="table table-bordered" style="white-space: nowrap">
              <tr>
                <th></th>
                <th></th>
                <th *ngFor="let c of columnsInCompare">
                  {{ c.c.caption }}
                </th>
              </tr>
              <ng-container *ngFor="let i of newRows">
                <tr>
                  <td>
                    <mat-icon
                      style="color: red"
                      (click)="newRows.splice(newRows.indexOf(i), 1)"
                    >
                      delete_forever</mat-icon
                    >
                  </td>
                  <td>{{ i.rowInExcel }}<br /></td>
                  <td *ngFor="let c of columnsInCompare">
                    {{ getColInfo(i, c).newDisplayValue }}
                  </td>
                </tr>
              </ng-container>
            </table>
          </div>
        </mat-tab>

        <mat-tab
          label="{{ settings.lang.existingFamilies }} - {{
            identicalRows.length
          }}"
          *ngIf="identicalRows && identicalRows.length"
        >
          <div class="table-div">
            <table class="table table-bordered" style="white-space: nowrap">
              <tr>
                <th></th>
                <th *ngFor="let c of columnsInCompare">
                  {{ c.c.caption }}
                </th>
              </tr>
              <ng-container *ngFor="let i of identicalRows">
                <tr>
                  <td>{{ i.rowInExcel }}<br /></td>
                  <td *ngFor="let c of columnsInCompare">
                    {{ getColInfo(i, c).newDisplayValue }}
                  </td>
                </tr>
              </ng-container>
            </table>
          </div>
        </mat-tab>
      </mat-tab-group>
      <button mat-raised-button (click)="createImportReport()">
        {{ settings.lang.saveExcelImportReport }}
      </button>
    </mat-step>
  </mat-horizontal-stepper>
</mat-card>
